<script setup lang="ts">
/**
 * PiIcon — typed wrapper for PrimeIcons font icons.
 *
 * Usage:
 *   <PiIcon name="home" />
 *   <PiIcon name="chevron-right" class="text-sm text-primary" />
 *
 * Renders: <i class="pi pi-{name}" />
 * Accepts any extra attrs (class, style, etc.) via inheritAttrs.
 */

export type PiIconName =
  | 'angle-right'
  | 'arrow-down'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'bars'
  | 'bell'
  | 'book'
  | 'bookmark'
  | 'bookmark-fill'
  | 'briefcase'
  | 'building'
  | 'building-columns'
  | 'calendar'
  | 'chart-bar'
  | 'check'
  | 'check-circle'
  | 'check-square'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'circle'
  | 'clock'
  | 'cog'
  | 'comments'
  | 'credit-card'
  | 'download'
  | 'exclamation-circle'
  | 'exclamation-triangle'
  | 'expand'
  | 'external-link'
  | 'eye'
  | 'file'
  | 'filter'
  | 'folder-open'
  | 'hammer'
  | 'home'
  | 'hourglass'
  | 'id-card'
  | 'images'
  | 'info-circle'
  | 'list-check'
  | 'lock'
  | 'map'
  | 'map-marker'
  | 'minus'
  | 'minus-circle'
  | 'moon'
  | 'pencil'
  | 'percentage'
  | 'phone'
  | 'plus'
  | 'refresh'
  | 'search'
  | 'shield'
  | 'shopping-bag'
  | 'sign-out'
  | 'sliders-h'
  | 'sparkles'
  | 'spinner'
  | 'star-fill'
  | 'sun'
  | 'times'
  | 'user'
  | 'user-plus'
  | 'users'
  | 'verified'
  | 'wallet'
  | 'wifi'
  | 'list'
  | 'ban'
  | 'send'
  | 'sort-alt'
  | 'sort-amount-down'
  | 'sort-amount-up'
  | 'tag'
  | 'th-large'
  | 'box'
  | 'arrow-circle-down'
  | 'arrow-circle-up'
  | 'copy'
  | 'times-circle'
  | 'envelope'
  | 'arrows-h'
  | 'table'
  | 'spin'
  | 'file-pdf'
  | 'file-excel'
  | 'ticket'
  | 'inbox'
  | 'headphones'
  | 'question-circle'
  | 'upload'
  | 'trash'
  | 'eye-slash'
  | 'star'
  | 'play'
  | 'youtube'
  | 'chart-line'
  | 'money-bill'
  | 'arrow-up-right'

interface Props {
  name: PiIconName
}

defineOptions({ inheritAttrs: false })
defineProps<Props>()
</script>

<template>
  <i :class="`pi pi-${name}`" v-bind="$attrs" />
</template>
